import React from 'react';
import './Home.css';
import { FaLinkedin, FaGithub, FaWhatsapp, FaArrowRight } from 'react-icons/fa';
import { SiUpwork, SiFreelancer } from 'react-icons/si';
import { Link } from 'react-router-dom';
import { logCustomEvent } from '../firebase';

const jobTitle = 'Flutter Expert & Web Developer | AI/LLM Expert.';

const MobileHome = () => (
  <section id="home" className="home-section home-section--mobile">
    <div className="home-content home-content--mobile">
      <div className="left-side">
        <h2>Hello, it&apos;s Junaid Nasir</h2>
        <h1 className="animated-title">
          And I&apos;m a <span className="typing">{jobTitle}</span>
        </h1>
        <p>
          I&apos;m passionate about creating clean and user-friendly mobile applications that provide
          seamless experiences. My goal is to bridge the gap between user needs and technological solutions.
        </p>
        <div className="social-icons2">
          <a
            href="https://www.linkedin.com/in/junaid-nasir-a44b03203/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
            target="_blank"
            rel="noopener noreferrer"
            className="hoverable"
            onClick={() => logCustomEvent('click_social_link', { platform: 'linkedin', location: 'home' })}
          >
            <FaLinkedin className="icon" />
          </a>
          <a
            href="https://github.com/junaid8262?tab=repositories"
            target="_blank"
            rel="noopener noreferrer"
            className="hoverable"
            onClick={() => logCustomEvent('click_social_link', { platform: 'github', location: 'home' })}
          >
            <FaGithub className="icon" />
          </a>
          <a
            href="https://www.upwork.com/freelancers/~0136f4598139fcbb51"
            target="_blank"
            rel="noopener noreferrer"
            className="hoverable"
            onClick={() => logCustomEvent('click_social_link', { platform: 'upwork', location: 'home' })}
          >
            <SiUpwork className="icon" />
          </a>
          <a
            href="https://www.freelancer.com/u/junaid8282"
            target="_blank"
            rel="noopener noreferrer"
            className="hoverable"
            onClick={() => logCustomEvent('click_social_link', { platform: 'freelancer', location: 'home' })}
          >
            <SiFreelancer className="icon" />
          </a>
          <a
            href="https://wa.me/923116741249"
            target="_blank"
            rel="noopener noreferrer"
            className="hoverable"
            onClick={() => logCustomEvent('click_social_link', { platform: 'whatsapp', location: 'home' })}
          >
            <FaWhatsapp className="icon" />
          </a>
        </div>
        <div className="portfolio-btn-wrapper" style={{ marginTop: '45px' }}>
          <Link
            to="/projects"
            className="btn-portfolio hoverable"
            onClick={() => logCustomEvent('click_view_portfolio', { location: 'home' })}
          >
            <span>View Portfolio</span>
            <FaArrowRight className="btn-arrow" />
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default MobileHome;
